import { Form } from "../../layout/FormLayout";
import {
  convertUserToOption,
  useFormWrapper,
  useStoreState,
} from "../../util/util";
import {
  ButtonContainer,
  PrimaryButtonLargeV2,
  SecondaryButtonLargeV2,
} from "../Buttons/Buttons";
import { SlideOut } from "../SlideOut/SlideOut";
import { Controller } from "react-hook-form";
import { SearchSelectInfiniteScroll } from "../SearchSelectInfiniteScroll/SearchSelectInfiniteScroll";
import { OptionType, User } from "../../types/types";
import { endpoints } from "../../endpoints";
import axios from "axios";
import { useContext, useState } from "react";
import { ChangeRequestUser } from "./ChangeRequestDetailPage";
import { Notifications } from "../Notifications/NotificationsContext";

type EditAssigneeSlideOutProps = {
  onClose: () => void;
  changeRequestId: string;
  assignee: ChangeRequestUser;
};

export const EditAssigneeSlideOut = ({
  onClose,
  changeRequestId,
  assignee,
}: EditAssigneeSlideOutProps) => {
  const { notifyError, notifySuccess } = useContext(Notifications);
  const [isLoading, setIsLoading] = useState(false);
  const { tenant_id, storefront_id } = useStoreState();
  const { handleSubmit, control, formState, errors } = useFormWrapper({
    defaultValues: {
      assignee: convertUserToOption(assignee),
    },
  });

  const onSubmit = async (input: { assignee: OptionType<string> }) => {
    setIsLoading(true);
    try {
      await axios.patch(
        endpoints.v2_tenants_id_change_requests_id(tenant_id, changeRequestId),
        {
          assignee_id: input.assignee.value,
        }
      );
      setIsLoading(false);
      onClose();
      notifySuccess("Assignee Updated!");
    } catch (error) {
      notifyError("There was an error updating the assignee");
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <SlideOut title={"Edit Assignee"} show closeFlyout={onClose}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name="assignee"
            rules={{
              required: true,
            }}
            render={(props) => (
              <SearchSelectInfiniteScroll
                {...props}
                placeholder={"Assignee"}
                baseUrl={endpoints.v1_storefronts_id_tenants_id_users(
                  storefront_id,
                  tenant_id
                )}
                params={(() => {
                  const params = new URLSearchParams();
                  params.append("order_by", "asc");
                  return params;
                })()}
                getOptions={(response: User[]) =>
                  response.reduce(
                    (acc, user) =>
                      user.is_active
                        ? [...acc, convertUserToOption(user)]
                        : acc,
                    [] as OptionType<string>[]
                  )
                }
                errors={errors}
                formState={formState}
              />
            )}
          />

          <ButtonContainer>
            <SecondaryButtonLargeV2 fullWidth onClick={onClose}>
              Cancel
            </SecondaryButtonLargeV2>
            <PrimaryButtonLargeV2 fullWidth loading={isLoading}>
              Save
            </PrimaryButtonLargeV2>
          </ButtonContainer>
        </Form>
      </SlideOut>
    </>
  );
};
